import { render, staticRenderFns } from "./ChampionsLeague.vue?vue&type=template&id=3b7f1654&"
import script from "./ChampionsLeague.vue?vue&type=script&lang=js&"
export * from "./ChampionsLeague.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports